import React, { useEffect, useState } from "react";
import { historyApi } from "../../config/api";
import { apiClient } from "../../utils/apiClient";
import "./history.scss";

const defaultData = {
  _id: null, Title: "History of the College", Content: "",
};

const History = () => {
  const [formData, setFormData] = useState(defaultData);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient(historyApi);
      const result = await response.json();
      if (response.ok && result.data) {
        const fetchedData = Array.isArray(result.data) ? result.data[0] : result.data;
        if (fetchedData) {
          setFormData(fetchedData);
        }
      }
    } catch (error) {
      console.error("Error fetching history data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const method = formData._id ? "PUT" : "POST";
      const url = formData._id ? `${historyApi}/${formData._id}` : historyApi;
      const response = await apiClient(url, {
        method,
        body: JSON.stringify(formData),
      });

      console.log(`[Frontend] History Response Status: ${response.status} ${response.statusText}`);
      const result = await response.json();
      console.log('[Frontend] History Response Body:', result);

      if (response.ok) {
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
        fetchData();
      } else {
        console.error('[Frontend] History save failed:', response.status);
      }
    } catch (error) {
      console.error("Error saving history data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="history-page">
      <div className="history-page__header">
        <div><h1>College History</h1><p>Update and manage the chronological journey and heritage information of the institution.</p></div>
        <button className="save-btn" type="submit" form="historyForm" disabled={loading}>{loading ? "Saving..." : saved ? "✓ Saved" : "Save History"}</button>
      </div>

      <form id="historyForm" className="history-form" onSubmit={handleSubmit}>
        <div className="history-card">
          <div className="form-section-label">General Configuration</div>
          <div className="form-group"><label>Display Title</label><input type="text" name="Title" value={formData.Title} onChange={handleChange} placeholder="e.g. History of the College" required /></div>
          
          <div className="form-section-label">Detailed Content</div>
          <div className="form-group"><label>Historical Narrative</label><textarea name="Content" rows="18" value={formData.Content} onChange={handleChange} placeholder="Describe the journey, foundation, and milestones of the college..." required /></div>
        </div>
      </form>
    </div>
  );
};

export default History;